export const onListGroupEnter = (
  event: React.KeyboardEvent<HTMLElement>,
  liElement: HTMLLIElement | null,
  toggleGroup: (event: React.KeyboardEvent<HTMLElement>) => void,
) => {
  // if keydown target is the root li, toggle the group
  if (event.target === liElement) {
    // only stop propagation if the event is not from a child element
    event.preventDefault()
    event.stopPropagation()
    toggleGroup(event)
  }
}

export const onListGroupArrowRight = (
  event: React.KeyboardEvent<HTMLElement>,
  liElement: HTMLLIElement | null,
  expandGroup: () => void,
) => {
  // Ignore if modifier keys are pressed
  // eslint-disable-next-line no-restricted-syntax
  if (event.altKey || event.metaKey) return
  event.preventDefault()
  event.stopPropagation()
  expandGroup()

  // if focus is on the root li, focus the first child ListItem
  if (event.target === liElement) {
    const firstChild = liElement.querySelector<HTMLLIElement>('[role=listitem]')
    firstChild?.focus()
  }
}

export const onListGroupArrowLeft = (
  event: React.KeyboardEvent<HTMLElement>,
  liElement: HTMLLIElement | null,
  collapseGroup: () => void,
) => {
  // Ignore if modifier keys are pressed
  // eslint-disable-next-line no-restricted-syntax
  if (event.altKey || event.metaKey) return
  event.preventDefault()
  event.stopPropagation()

  // always bring focus up to root li
  liElement?.focus()

  // if keydown target is the root li, collapse the group
  if (event.target === liElement) {
    collapseGroup()
  }
}
